import { render, staticRenderFns } from "./AiIntroducePage.vue?vue&type=template&id=cbd123e8&scoped=true&"
import script from "./AiIntroducePage.vue?vue&type=script&lang=js&"
export * from "./AiIntroducePage.vue?vue&type=script&lang=js&"
import style0 from "./AiIntroducePage.vue?vue&type=style&index=0&id=cbd123e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd123e8",
  null
  
)

export default component.exports